import { ArrowRight } from "lucide-react";

function Step({ label, value, accent, testId }) {
  return (
    <div className="flex-1 min-w-0 text-center" data-testid={testId}>
      <div className={`font-serif leading-none ${accent ? "text-4xl sm:text-5xl text-teal-300" : "text-3xl sm:text-4xl"}`}>{value}</div>
      <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground mt-2">{label}</div>
    </div>
  );
}

// clicks → signups → members → earnings, kept very visual.
export default function EarningsFlow({ k }) {
  const arrow = <ArrowRight className="w-4 h-4 text-muted-foreground/50 shrink-0 mt-3" />;
  return (
    <section className="rounded-3xl border border-border bg-card/40 p-6 sm:p-8 mb-12" data-testid="partner-flow">
      <div className="flex items-start gap-2 sm:gap-4">
        <Step label="Visitors" value={k.clicks} testId="partner-clicks" />{arrow}
        <Step label="Signups" value={k.signups} testId="partner-signups" />{arrow}
        <Step label="Members" value={k.paid} testId="partner-paid" />{arrow}
        <Step label="Earned" value={`£${Math.round(k.earned_gbp)}`} accent testId="partner-earnings" />
      </div>
      <p className="text-xs text-muted-foreground text-center mt-6">Still owed to you: <span className="text-foreground" data-testid="partner-owed">£{k.owed_gbp.toFixed(2)}</span> · Payouts from £{k.payout_min}</p>
    </section>
  );
}
